export type RecordType = 'fine' | 'complaint';
export type RecordStatus = 'open' | 'dismissed' | 'closed';

export interface StudentInfo {
  id: number;
  full_name: string;
  student_uid: string;
}

export interface ComplaintFineRecord {
  id: number;
  student_id: number;
  student: StudentInfo;
  record_type: RecordType;
  status: RecordStatus;
  reason: string;
  custom_reason: string | null;
  remarks: string;
  date: string;
  amount: number;
  amount_paid?: number;
  balance?: number;
  created_by: number;
  creator: { id: number; name: string } | null;
  created_at: string;
  updated_at: string;
}

export const FINE_REASON_OPTIONS: { value: string; label: string }[] = [
  { value: 'late_fee',           label: 'Late Fee' },
  { value: 'library_fine',       label: 'Library Fine' },
  { value: 'attendance_fine',    label: 'Attendance Fine' },
  { value: 'damage_to_property', label: 'Damage to Property' },
  { value: 'uniform_violation',  label: 'Uniform Violation' },
  { value: 'misconduct',         label: 'Misconduct' },
  { value: 'lost_id_card',       label: 'Lost ID Card' },
  { value: 'other',              label: 'Other' },
];

export const COMPLAINT_REASON_OPTIONS: { value: string; label: string }[] = [
  { value: 'property_damage', label: 'Property Damage' },
  { value: 'behavior',        label: 'Behavior' },
  { value: 'academic',        label: 'Academic' },
  { value: 'attendance',      label: 'Attendance' },
  { value: 'other',           label: 'Other' },
];

export const RECORD_STATUS_OPTIONS: { value: string; label: string }[] = [
  { value: 'open',      label: 'Open' },
  { value: 'dismissed', label: 'Dismissed' },
  { value: 'closed',    label: 'Closed' },
];

export const RECORD_STATUS_STYLES: Record<RecordStatus, { bg: string; text: string; border: string }> = {
  open:      { bg: '#FFF9E6', text: '#B45309', border: '#F59E0B40' },
  dismissed: { bg: '#F5F5F5', text: '#6B7280', border: '#9CA3AF40' },
  closed:    { bg: '#F1F5F9', text: '#475569', border: '#94A3B840' },
};

export const STATUS_LABEL: Record<RecordStatus, string> = {
  open:      'Open',
  dismissed: 'Dismissed',
  closed:    'Closed',
};

export const labelForReason = (reason: string): string => {
  const all = [...FINE_REASON_OPTIONS, ...COMPLAINT_REASON_OPTIONS];
  return all.find(o => o.value === reason)?.label ?? reason;
};
